import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setFadeoutAppAction } from '../../../app/action'
import { EDIT_DOMAIN_PAGE, EDIT_PRODUCT_PAGE } from '../../../utilities/function/common'
import { getPageByURL } from '../../../utilities/function/urlparams'

let CloseButton = (props) => {
  const {className,label,location} = props
  const dispatch = useDispatch()
  const buttonOnclick = () => {
    const { history } = props
    dispatch(setFadeoutAppAction(true))
    window.setTimeout(() => {
      dispatch(setFadeoutAppAction(false))
      const pageType = getPageByURL(location.search)
      if(pageType===EDIT_DOMAIN_PAGE || pageType===EDIT_PRODUCT_PAGE){
        history.push(history.location.pathname+'?a=checkout')
      }else{
        history.push(history.location.pathname)
      }
    }, 300)
  }

  return (
    <div className={`of-close-button-wrapper${className? ' '+className:''}`}>
      <div className='of-close-button side-panel-background-1-100' onClick={buttonOnclick}>
        <div className='of-close-button__text'>{label?label:'Close'}</div>
        <i className='of-close-button__icon icon-of-blog-close' />
      </div>
    </div>
  )
}

CloseButton.propTypes = {
  history: PropTypes.any,
  className: PropTypes.string,
  label: PropTypes.string,
  location: PropTypes.object
}

CloseButton = withRouter(CloseButton)

export default CloseButton
